import { render, staticRenderFns } from "./DeliveredPerMonthTable.vue?vue&type=template&id=1d595672&"
import script from "./DeliveredPerMonthTable.vue?vue&type=script&lang=js&"
export * from "./DeliveredPerMonthTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports